import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import MLCD from './Mlcd';
import NamedEntity from './NamedEntity';
import CustomEntityType from './CustomEntityType';
import $ from 'jquery';

class EntityMainTab extends Component {

    componentDidMount() {
        (function () {
            var currentPath = window.location.href;
            var path = window.origin + "/platform/projectmgmt/multilingual";
            var path1 = window.origin + "/platform/projectmgmt/multilingual/";
            if (currentPath === path || currentPath === path1) {
                $("#mlcd-tab").addClass('active');

            } else if (currentPath.includes('/multilingual/custom-entity-type')) {
                $("#custom-entity-type-tab").addClass('active');
              }else if (currentPath.includes('/multilingual/language-specific-entity')) {
                $("#named-entity-tab").addClass('active');
              } $("#mlcd-tab,#named-entity-tab,#custom-entity-type-tab")
                .on("click", function () {
                    $("#mlcd-tab,#named-entity-tab,#custom-entity-type-tab")
                        .removeClass('active');
                    localStorage.setItem("last-used-team-settings-sub-tab", $(this)[0].id);
                    $(this).addClass('active')
                })
        })();
    }
    render() {
        return (

            <div id="tabPage" >
                <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | Clusters Details</title>
                    {/* Font Awesome Icons */}
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    {/* IonIcons */}
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    {/* Theme style */}
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="./assets/css/toggleButton.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />

                    <div className="container-fluid" style={{ marginLeft: '0px' }} >
                        {/* Nav tabs */}
                        <div className="tab-class">
                            <ul className="nav nav-tabs border-bottom navCluster" >
                            <Link className="nav-item" data-toggle="tab" 
                    to="/projectmgmt/multilingual" style={{ textDecoration: 'none' }}>
                    <li className="nav-link" id="mlcd-tab">
                      Multilingual Entities
                    </li></Link>
                    <Link to="/projectmgmt/multilingual/language-specific-entity" className="nav-item" data-toggle="tab" 
                    style={{ textDecoration: 'none' }}>
                    <li className="nav-link" id="named-entity-tab">
                      Language Specific Entities
                                      </li>
                  </Link>
                  <Link to="/projectmgmt/multilingual/custom-entity-type" className="nav-item" data-toggle="tab" 
                    style={{ textDecoration: 'none' }}>
                    <li className="nav-link" id="custom-entity-type-tab">
                      Custom Entity Types
                                      </li>
                  </Link>

                            </ul>
                        </div>
                    </div>
                </div>
                <Switch>
                <Route path="/projectmgmt/multilingual/custom-entity-type" component={CustomEntityType}></Route>
                    <Route path="/projectmgmt/multilingual/language-specific-entity" component={NamedEntity}></Route>
                    <Route path="/projectmgmt/multilingual" component={MLCD}></Route>
                </Switch>
            </div>

        );
    }
}
export default EntityMainTab;


// WEBPACK FOOTER //
// ./src/projectmgmt/MultiLingualData/EntitiesMainTab.js